import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const adminService = {
    fetchAdminsList,
    createAdmin,
    updateAdmin,
    disableAdmin
};

function fetchAdminsList(signal) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        ...(signal && { signal })
    };

    return axiosInstance.get(api.admins.fetchadminslist, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error?.response || error));
}


function createAdmin(adminDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.admins.createadmin, adminDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error?.response || error));
}

function updateAdmin(adminDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.admins.updateadmin, adminDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error?.response || error));
}

function disableAdmin(adminId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.admins.deleteadmin}/${adminId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error?.response || error));
}